import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import exportValue from "../apiconfig";
import { borderRadius } from "@mui/system";
import moment from "moment";
import Moment from "react-moment";

const Left_panel = ({ isSidebarOpen, toggleSidebar, props }) => {
  const support = exportValue.SUPPORT;
  const reports = exportValue.REPORTS;
  let navigate = useNavigate();
  let loginDetail = localStorage.getItem("admin_login");
  if (loginDetail == null) {
    console.log("asfsf");
    navigate("/login");
  } else {
    loginDetail = JSON.parse(localStorage.getItem("admin_login"));
  }
  let admindata = {};
  if (localStorage.getItem("admin_login")) {
    admindata = JSON.parse(localStorage.getItem("admin_login"));
    // console.log("admindata------>  -  ", admindata);
  }
  return (
    <>
      <aside class="sidebar ">
        <div class="sidebar-header">
          <img src="../../../assets/img/logo_sky.png" alt="logo" />
          <a href="/dashboard">
            {" "}
            <h2>JetPost</h2>
          </a>
        </div>
        <ul class="sidebar-links">
          {admindata.admin_type != 5 && admindata.admin_type != 12 ? (
            <h4>
              <span>Main Menu</span>
              <div class="menu-separator"></div>
            </h4>
          ) : (
            ""
          )}
          {admindata.admin_type != 5 && admindata.admin_type != 12 ? (
            <li class="active">
              <a href="/">
                <i class="bx bx-grid-alt"></i>Dashboard
              </a>
            </li>
          ) : (
            ""
          )}
          {/* {admindata.admin_type != 12  ?
            <li class="">
              <a href="/ndr_dashboard"><i class='bx bx-grid-alt' ></i>NDR Dashboard</a>
            </li>
            :""} */}
          {admindata.admin_type == 2 ||
          admindata.admin_type == 10 ||
          admindata.admin_type == 11 ||
          admindata.admin_type == 12 ? (
            <li class="submenu ">
              <a href="/shipments">
                <i class="bx bx-package"></i> Shipments
                <span>
                  <i class="bx bx-chevron-down"></i>
                </span>
              </a>
              <ul class="submenu-links">
                <li class="active">
                  <a href="/shipments?type=1" class="active">
                    <i class="bx bx-circle"></i> B2C Shipments
                  </a>
                </li>
                <li class="active">
                  <a href="/return_shipments">
                    <i class="bx bx-circle"></i> Returns Management
                  </a>
                </li>
                {/* {admindata.admin_type != 12 ? (
                  <li class="active">
                    <a href="/shipments?type=2">
                      <i class="bx bx-circle"></i> B2B Shipments
                    </a>
                  </li>
                ) : (
                  ""
                )} */}

                {/* <li><a href="/delivered_shipments"><i class='bx bx-circle' ></i> Delivered Shipments</a></li>
            <li><a href="/undelivered_shipments"><i class='bx bx-circle' ></i> Undelivered Shipments</a></li> */}

                {admindata.admin_type != 12 ? (
                  <li>
                    <a href="/ndr_shipments">
                      <i class="bx bx-circle"></i> Ndr Shipments
                    </a>
                  </li>
                ) : (
                  ""
                )}
                {admindata.admin_type != 12 ? (
                  <li>
                    <a href="/failed_shipments">
                      <i class="bx bx-circle"></i> Failed Shipments
                    </a>
                  </li>
                ) : (
                  ""
                )}
              </ul>
            </li>
          ) : admindata.admin_type == 3 &&
            admindata.previlage &&
            admindata.previlage.shipments != undefined &&
            admindata.previlage.shipments != false ? (
            <li class="submenu ">
              <a href="/shipments">
                <i class="bx bx-package"></i> Shipments
                <span>
                  <i class="bx bx-chevron-down"></i>
                </span>
              </a>
              <ul class="submenu-links">
                <li class="active">
                  <a href="/shipments" class="active">
                    <i class="bx bx-circle"></i> All Shipments
                  </a>
                </li>
                {/* <li><a href="/delivered_shipments"><i class='bx bx-circle' ></i> Delivered Shipments</a></li>
          <li><a href="/undelivered_shipments"><i class='bx bx-circle' ></i> Undelivered Shipments</a></li> */}
                <li>
                  <a href="/ndr_shipments">
                    <i class="bx bx-circle"></i> Ndr Shipments
                  </a>
                </li>
                <li>
                  <a href="/failed_shipments">
                    <i class="bx bx-circle"></i> Failed Shipments
                  </a>
                </li>
              </ul>
            </li>
          ) : (
            ""
          )}

          {admindata.admin_type == 2 ? (
            <li>
              <a href="/customers?type=1">
                <i class="bx bx-user"></i>Clients
              </a>
              {/* <a href="/customers?type=5"><i class='bx bx-user' ></i>Franchises</a> */}
            </li>
          ) : admindata.admin_type == 3 &&
            admindata.previlage &&
            admindata.previlage.customers != undefined &&
            admindata.previlage.customers != false ? (
            <li>
              <a href="/customers?type=1">
                <i class="bx bx-user"></i>Clients
              </a>
              {/* <a href="/customers?type=5"><i class='bx bx-user' ></i>Franchises</a> */}
            </li>
          ) : (
            ""
          )}

          {admindata.admin_type == 10 || admindata.admin_type == 11 ? (
            <li>
              <a href="/my_referrals">
                <i class="bx bx-user"></i>My Referrals
              </a>
            </li>
          ) : (
            ""
          )}
          {admindata.admin_type == 10 || admindata.admin_type == 11 ? (
            <li>
              <a href="/my_earnings">
                <i class="bx bx-user"></i>My Earnings
              </a>
            </li>
          ) : (
            ""
          )}

          {admindata.admin_type == 2 ? (
            <li class="submenu">
              <a href="/payments">
                <i class="bx bx-wallet"></i> Payments
                <span>
                  <i class="bx bx-chevron-down"></i>
                </span>
              </a>
              <ul class="submenu-links">
                <li>
                  <a href="/payments">
                    <i class="bx bx-circle"></i> Shipment Payments
                  </a>
                </li>
                <li>
                  <a href="/user_cod_wallet">
                    <i class="bx bx-circle"></i> COD Wallet transactions
                  </a>
                </li>
                <li>
                  <a href="/wallet_payments">
                    <i class="bx bx-circle"></i> Wallet Payments
                  </a>
                </li>
                <li>
                  <a href="/payment_gateway_payments">
                    <i class="bx bx-circle"></i> Wallet Recharge Payment
                    Gateways
                  </a>
                </li>
                {/* <li><a href="#"><i class='bx bx-circle' ></i> COD Payouts</a></li> */}
                {/* <li><a href="/payout"><i class='bx bx-circle' ></i> Payouts</a></li> */}
              </ul>
            </li>
          ) : admindata.admin_type == 3 &&
            admindata.previlage &&
            admindata.previlage.payments != undefined &&
            admindata.previlage.payments != false ? (
            <li class="submenu">
              <a href="/payments">
                <i class="bx bx-wallet"></i> Payments
                <span>
                  <i class="bx bx-chevron-down"></i>
                </span>
              </a>
              <ul class="submenu-links">
                <li>
                  <a href="/payments">
                    <i class="bx bx-circle"></i> Shipment Payments
                  </a>
                </li>
                <li>
                  <a href="/user_cod_wallet">
                    <i class="bx bx-circle"></i> COD Wallet transactions
                  </a>
                </li>
                <li>
                  <a href="/wallet_payments">
                    <i class="bx bx-circle"></i> Wallet Payments
                  </a>
                </li>
                <li>
                  <a href="/payment_gateway_payments">
                    <i class="bx bx-circle"></i> Wallet Recharge Payment
                    Gateways
                  </a>
                </li>
                {/* <li><a href="#"><i class='bx bx-circle' ></i> COD Payouts</a></li> */}
                {/* <li><a href="/payout"><i class='bx bx-circle' ></i> Payouts</a></li> */}
              </ul>
            </li>
          ) : (
            ""
          )}

          {admindata.admin_type == 2 ? (
            <li class="submenu">
              <a href="#">
                <i class="bx bx-money"></i> COD Management
                <span>
                  <i class="bx bx-chevron-down"></i>
                </span>
              </a>
              <ul class="submenu-links">
                <li>
                  <a href="/payout">
                    <i class="bx bx-circle"></i> COD Payouts
                  </a>
                </li>
                <li>
                  <a href="/cod_mismatch">
                    <i class="bx bx-circle"></i> COD Mismatch
                  </a>
                </li>
                {/* <li><a href="/prepayoutSummary"><i class='bx bx-circle' ></i>Pre Payout Summary</a></li> */}
              </ul>
            </li>
          ) : admindata.admin_type == 3 &&
            admindata.previlage &&
            admindata.previlage.payments != undefined &&
            admindata.previlage.payments != false ? (
            <li class="submenu">
              <a href="#">
                <i class="bx bx-money"></i> COD Management
                <span>
                  <i class="bx bx-chevron-down"></i>
                </span>
              </a>
              <ul class="submenu-links">
                <li>
                  <a href="/payout">
                    <i class="bx bx-circle"></i> COD Payouts
                  </a>
                </li>
                <li>
                  <a href="/cod_mismatch">
                    <i class="bx bx-circle"></i> COD Mismatch
                  </a>
                </li>
                {/* <li><a href="/prepayoutSummary"><i class='bx bx-circle' ></i>Pre Payout Summary</a></li> */}
              </ul>
            </li>
          ) : (
            ""
          )}

          {admindata.admin_type == 2 ||
          admindata.admin_type == 10 ||
          admindata.admin_type == 11 ? (
            <li class="submenu">
              <a href="#">
                <i class="bx bx-money"></i> Referral Management
                <span>
                  <i class="bx bx-chevron-down"></i>
                </span>
              </a>
              <ul class="submenu-links">
                <li>
                  <a href="/payouts_referral">
                    <i class="bx bx-circle"></i> Referral Payouts
                  </a>
                </li>
              </ul>
            </li>
          ) : admindata.admin_type == 3 &&
            admindata.previlage &&
            admindata.previlage.payments != undefined &&
            admindata.previlage.payments != false ? (
            <li class="submenu">
              <a href="#">
                <i class="bx bx-money"></i> Referral Management
                <span>
                  <i class="bx bx-chevron-down"></i>
                </span>
              </a>
              <ul class="submenu-links">
                <li>
                  <a href="/payouts_referral">
                    <i class="bx bx-circle"></i> Referral Payouts
                  </a>
                </li>
              </ul>
            </li>
          ) : (
            ""
          )}

          {admindata.admin_type == 2 ? (
            <li class="submenu">
              <a href="/users">
                <i class="bx bx-user-check"></i> Users Management
                <span>
                  <i class="bx bx-chevron-down"></i>
                </span>
              </a>
              <ul class="submenu-links">
                <li>
                  <a href="/users">
                    <i class="bx bx-circle"></i> Staff Users
                  </a>
                </li>
                <li>
                  <a href="/dispatchers">
                    <i class="bx bx-circle"></i> Dispatchers
                  </a>
                </li>
              </ul>
            </li>
          ) : admindata.admin_type == 3 &&
            admindata.previlage.users != undefined &&
            admindata.previlage.users != false ? (
            <li class="submenu">
              <a href="/users">
                <i class="bx bx-user-check"></i> Users Management
                <span>
                  <i class="bx bx-chevron-down"></i>
                </span>
              </a>
              <ul class="submenu-links">
                <li>
                  <a href="/users">
                    <i class="bx bx-circle"></i> Staff Users
                  </a>
                </li>
                <li>
                  <a href="/dispatchers">
                    <i class="bx bx-circle"></i> Dispatchers
                  </a>
                </li>
              </ul>
            </li>
          ) : (
            ""
          )}

          <h4>
            <span>Other</span>
            <div class="menu-separator"></div>
          </h4>
          {support &&
          admindata.admin_type != 4 &&
          admindata.admin_type != 5 &&
          admindata.admin_type != 12 ? (
            <li>
              <a href="/tickets">
                <i class="bx bx-support"></i>Support
              </a>
            </li>
          ) : (
            ""
          )}
          {admindata.admin_type != 10 && admindata.admin_type != 11 ? (
            <li>
              <a href="/pending_kyc">
                <i class="bx bx-id-card"></i>KYC Management
              </a>
            </li>
          ) : (
            ""
          )}
          {admindata.admin_type != 12 ? (
            <li>
              <a href="/carousel_setup">
                <i class="bx bx-id-card"></i>Carousel Setup
              </a>
            </li>
          ) : (
            ""
          )}

          {/* {reports && admindata.admin_type != 4 && admindata.admin_type != 5  && admindata.admin_type != 12?
            <li class="submenu">
              <a href="/shipment_report">
                <i class='bx bx-receipt' ></i> Reports
                <span><i class='bx bx-chevron-down' ></i></span>
              </a>
              <ul class="submenu-links">
                <li><a href="/shipment_report"><i class='bx bx-circle' ></i> Shipment Reports</a></li>
                {admindata.admin_type != 10 && admindata.admin_type != 11 ? <li><a href="/missing_pincodes"><i class='bx bx-circle' ></i> Missing Pincode Reports</a></li> : ""}
                {admindata.admin_type != 10 && admindata.admin_type != 11 ? <li><a href="/invoices"><i class='bx bx-circle' ></i> Customer Invoices</a></li> : ""}
                {admindata.admin_type != 10 && admindata.admin_type != 11 ? <li><a href="/notification_log"><i class='bx bx-circle' ></i> Notifications</a></li> : ""}
              </ul>
            </li>
            : ""} */}
          {reports && admindata.admin_type != 4 && admindata.admin_type != 5 ? (
            <li className="submenu">
              <a href="/shipment_report">
                <i className="bx bx-receipt"></i> Reports
                <span>
                  <i className="bx bx-chevron-down"></i>
                </span>
              </a>

              <ul className="submenu-links">
                <li>
                  <a href="/shipment_report">
                    <i className="bx bx-circle"></i> Shipment Reports
                  </a>
                </li>

                {admindata.admin_type != 10 &&
                  admindata.admin_type != 11 &&
                  admindata.admin_type != 12 && (
                    <>
                      <li>
                        <a href="/missing_pincodes">
                          <i className="bx bx-circle"></i> Missing Pincode
                          Reports
                        </a>
                      </li>

                      <li>
                        <a href="/invoices">
                          <i className="bx bx-circle"></i> Customer Invoices
                        </a>
                      </li>
                      {/* <li>
                        <a href="/invoices_v1.1">
                          <i className="bx bx-circle"></i> Customer Invoices 1.1
                        </a>
                      </li> */}
                      <li>
                        <a href="/invoices_v2">
                          <i className="bx bx-circle"></i> Customer Invoices V2
                        </a>
                      </li>
                    </>
                  )}

                {(admindata.admin_type == 10 ||
                  admindata.admin_type == 12 ||
                  admindata.admin_type == 2) && (
                  <>
                    <li>
                      <a href="/notification_log">
                        <i className="bx bx-circle"></i> Notifications
                      </a>
                    </li>
                    <li>
                      <a href="/subscription_logs">
                        <i className="bx bx-circle"></i> Subscription Logs
                      </a>
                    </li>
                    <li>
                      <a href="/vas_logs">
                        <i className="bx bx-circle"></i> VAS Logs
                      </a>
                    </li>
                  </>
                )}
              </ul>
            </li>
          ) : (
            ""
          )}

          {admindata.admin_type == 2 ? (
            <h4>
              <span>Master</span>
              <div class="menu-separator"></div>
            </h4>
          ) : admindata.admin_type == 3 &&
            admindata.previlage.users != undefined &&
            admindata.previlage.users != false ? (
            <h4>
              <span>Master</span>
              <div class="menu-separator"></div>
            </h4>
          ) : (
            ""
          )}

          {admindata.admin_type == 2 ? (
            <li class="submenu">
              <a href="/master_new">
                <i class="bx bx-hive"></i> Master Settings
                <span>
                  <i class="bx bx-chevron-down"></i>
                </span>
              </a>
              <ul class="submenu-links">
                <li>
                  <a href="/master_new">
                    <i class="bx bx-circle"></i> Master Settings
                  </a>
                </li>
                <li>
                  <a href="/carrier_list">
                    <i class="bx bx-circle"></i> Carrier Managment
                  </a>
                </li>
                <li>
                  <a href="/pricing_chart">
                    <i class="bx bx-circle"></i>Pricing Chart
                  </a>
                </li>

                <li>
                  <a href="/zone_list">
                    <i class="bx bx-circle"></i> Zone Management
                  </a>
                </li>
                <li>
                  <a href="/b2b_zone_management">
                    <i class="bx bx-circle"></i> B2b Zone Managment
                  </a>
                </li>
                {/* <li><a href="/international_zone_management"><i class='bx bx-circle' ></i> International Zone</a></li> */}
                <li>
                  <a href="/product">
                    <i class="bx bx-circle"></i> Product Managment
                  </a>
                </li>
                <li>
                  <a href="/servicable_carriers">
                    <i class="bx bx-circle"></i> Servicable Pincodes
                  </a>
                </li>
                <li>
                  <a href="/country_list">
                    <i class="bx bx-circle"></i> Location Managment
                  </a>
                </li>
                <li>
                  <a href="/vas_prices">
                    <i class="bx bx-circle"></i> VAS Prices
                  </a>
                </li>
                <li>
                  <a href="/client_pricing">
                    <i class="bx bx-circle"></i> Client Pricing
                  </a>
                </li>
              </ul>
            </li>
          ) : admindata.admin_type == 3 &&
            admindata.previlage.users != undefined &&
            admindata.previlage.users != false ? (
            <li class="submenu">
              <a href="/master_new">
                <i class="bx bx-hive"></i> Master Settings
                <span>
                  <i class="bx bx-chevron-down"></i>
                </span>
              </a>
              <ul class="submenu-links">
                <li>
                  <a href="/master_new">
                    <i class="bx bx-circle"></i> Master Settings
                  </a>
                </li>
                <li>
                  <a href="/carrier_list">
                    <i class="bx bx-circle"></i> Carrier Managment
                  </a>
                </li>
                <li>
                  <a href="/pricing_chart">
                    <i class="bx bx-circle"></i>Pricing Chart
                  </a>
                </li>

                <li>
                  <a href="/zone_list">
                    <i class="bx bx-circle"></i> Zone Management
                  </a>
                </li>
                <li>
                  <a href="/b2b_zone_management">
                    <i class="bx bx-circle"></i> B2b Zone Managment
                  </a>
                </li>
                {/* <li><a href="/international_zone_management"><i class='bx bx-circle' ></i> International Zone</a></li> */}
                <li>
                  <a href="/product">
                    <i class="bx bx-circle"></i> Product Managment
                  </a>
                </li>
                <li>
                  <a href="/servicable_carriers">
                    <i class="bx bx-circle"></i> Servicable Pincodes
                  </a>
                </li>
                <li>
                  <a href="/country_list">
                    <i class="bx bx-circle"></i> Location Managment
                  </a>
                </li>
                <li>
                  <a href="/vas_prices">
                    <i class="bx bx-circle"></i> VAS Prices
                  </a>
                </li>
                <li>
                  <a href="/client_pricing">
                    <i class="bx bx-circle"></i> Client Pricing
                  </a>
                </li>
              </ul>
            </li>
          ) : (
            ""
          )}

          {admindata.admin_type == 2 ? (
            <h4>
              <span>Settings</span>
              <div class="menu-separator"></div>
            </h4>
          ) : admindata.admin_type == 3 &&
            admindata.previlage.system_settings != undefined &&
            admindata.previlage.system_settings != false ? (
            <h4>
              <span>Settings</span>
              <div class="menu-separator"></div>
            </h4>
          ) : (
            ""
          )}

          {admindata.admin_type == 2 ? (
            <li class="submenu">
              <a href="/system_settings">
                <i class="bx bx-cog"></i> Settings
                <span>
                  <i class="bx bx-chevron-down"></i>
                </span>
              </a>
              <ul class="submenu-links">
                <li>
                  <a href="/system_settings">
                    <i class="bx bx-circle"></i> Company Settings
                  </a>
                </li>
                <li>
                  <a href="/system_settings">
                    <i class="bx bx-circle"></i> Social Settings
                  </a>
                </li>
                <li>
                  <a href="/system_settings">
                    <i class="bx bx-circle"></i> Payment Gateway Settings
                  </a>
                </li>
                <li>
                  <a href="/system_settings">
                    <i class="bx bx-circle"></i> SMTP Settings
                  </a>
                </li>
                <li>
                  <a href="/system_settings">
                    <i class="bx bx-circle"></i> Email Template Settings
                  </a>
                </li>
                <li>
                  <a href="/announcement">
                    <i class="bx bx-circle"></i> Announcement
                  </a>
                </li>
                <li>
                  <a href="/news_management">
                    <i class="bx bx-circle"></i> News Management
                  </a>
                </li>
                <li>
                  <a href="/customer_ratings">
                    <i class="bx bx-circle"></i> Customer Ratings
                  </a>
                </li>
              </ul>
            </li>
          ) : admindata.admin_type == 3 &&
            admindata.previlage.system_settings != undefined &&
            admindata.previlage.system_settings != false ? (
            <li class="submenu">
              <a href="/system_settings">
                <i class="bx bx-cog"></i> Settings
                <span>
                  <i class="bx bx-chevron-down"></i>
                </span>
              </a>
              <ul class="submenu-links">
                <li>
                  <a href="/system_settings">
                    <i class="bx bx-circle"></i> Company Settings
                  </a>
                </li>
                <li>
                  <a href="/system_settings">
                    <i class="bx bx-circle"></i> Social Settings
                  </a>
                </li>
                <li>
                  <a href="/system_settings">
                    <i class="bx bx-circle"></i> Payment Gateway Settings
                  </a>
                </li>
                <li>
                  <a href="/system_settings">
                    <i class="bx bx-circle"></i> SMTP Settings
                  </a>
                </li>
                <li>
                  <a href="/system_settings">
                    <i class="bx bx-circle"></i> Email Template Settings
                  </a>
                </li>
                <li>
                  <a href="/announcement">
                    <i class="bx bx-circle"></i> Announcement
                  </a>
                </li>
                <li>
                  <a href="/news_management">
                    <i class="bx bx-circle"></i> News Management
                  </a>
                </li>
                <li>
                  <a href="/customer_ratings">
                    <i class="bx bx-circle"></i> Customer Ratings
                  </a>
                </li>
              </ul>
            </li>
          ) : (
            ""
          )}

          {admindata.admin_type == 12 || admindata.admin_type == 2 ? (
            <>
              <li class="submenu">
                <a href="#">
                  <i class="bx bx-receipt"></i> Lead Management
                  <span>
                    <i class="bx bx-chevron-down"></i>
                  </span>
                </a>
                <ul class="submenu-links">
                  <li>
                    <a href="/lead_form">
                      <i class="bx bx-circle"></i> Calendar
                    </a>
                  </li>
                </ul>
              </li>
            </>
          ) : (
            ""
          )}

          {admindata.admin_type != 12 ? (
            <h4>
              <span>Tools</span>
              <div class="menu-separator"></div>
            </h4>
          ) : (
            ""
          )}
          {admindata.admin_type != 12 ? (
            <li class="submenu">
              <a href="/weight_discrepancies">
                <i class="bx bx-cylinder"></i> Weight Discrepancies
                <span>
                  <i class="bx bx-chevron-down"></i>
                </span>
              </a>
              <ul class="submenu-links">
                <li>
                  <a href="/weight_discrepancies">
                    <i class="bx bx-circle"></i>B2C
                  </a>
                </li>
                {/* <li><a href="/weight_discrepancies_b2b"><i class='bx bx-circle' ></i>B2B</a></li> */}
              </ul>
            </li>
          ) : (
            ""
          )}
          {/* {admindata.admin_type == 2 ?
            <li>
              <a href="/post_delivery_pricing"><i class='bx bx-purchase-tag' ></i>VAS Charges</a>

            </li>
            : ""} */}
          {admindata.admin_type == 2 ? (
            <li>
              <a href="/auto_post_delivery_pricing">
                <i class="bx bx-purchase-tag"></i>Auto VAS Charges
              </a>
            </li>
          ) : (
            ""
          )}
          {admindata.admin_type != 12 ? (
            <li class="submenu">
              <a href="/weight_discrepancies_dispute">
                <i class="bx bx-cylinder"></i> Discrepancies Dispute
                <span>
                  <i class="bx bx-chevron-down"></i>
                </span>
              </a>
              <ul class="submenu-links">
                <li>
                  <a href="/weight_discrepancies_dispute">
                    <i class="bx bx-circle"></i>B2C
                  </a>
                </li>
                <li>
                  <a href="/weight_discrepancies_dispute_b2b">
                    <i class="bx bx-circle"></i>B2B
                  </a>
                </li>
              </ul>
            </li>
          ) : (
            ""
          )}
          {/* <li>
         <a href="/weight_discrepancies_dispute"><i class='bx bx-cylinder' ></i>Discrepancies Dispute</a>
         
      </li> */}
          {admindata.admin_type != 10 &&
          admindata.admin_type != 11 &&
          admindata.admin_type != 12 ? (
            <li class="submenu">
              <a href="/zone_calculator">
                <i class="bx bx-calculator"></i> Rate Calculator
                <span>
                  <i class="bx bx-chevron-down"></i>
                </span>
              </a>
              <ul class="submenu-links">
                <li>
                  <a href="/zone_calculator">
                    <i class="bx bx-calculator"></i>B2C
                  </a>
                </li>
                <li>
                  <a href="/b2b_zone_calculator">
                    <i class="bx bx-calculator"></i>B2B
                  </a>
                </li>
              </ul>
            </li>
          ) : (
            ""
          )}

          {admindata.admin_type != 10 &&
          admindata.admin_type != 11 &&
          admindata.admin_type != 12 ? (
            <li>
              <a href="/search_pincode">
                <i class="bx bx-search"></i>Search Pincode
              </a>
            </li>
          ) : (
            ""
          )}

          {admindata.admin_type != 10 &&
          admindata.admin_type != 11 &&
          admindata.admin_type != 12 ? (
            <li>
              <a href="/high_risk_pincode">
                <i class="bx bx-search"></i>High Risk Pincode
              </a>
            </li>
          ) : (
            ""
          )}

          {admindata.admin_type == 4 ? (
            <li class="submenu">
              <a href="/ship_1?value=0">
                <i class="bx bx-cog"></i> Create Order
                <span>
                  <i class="bx bx-chevron-down"></i>
                </span>
              </a>
              <ul class="submenu-links">
                <li>
                  <a href="/orders">
                    <i class="bx bx-circle"></i> Order List
                  </a>
                </li>
                <li>
                  <a
                    onClick={() =>
                      navigate({
                        pathname: "/ship_1",
                        search: `value=0`,
                      })
                    }
                  >
                    <i class="bx bx-circle"></i> Create Shipment
                  </a>
                </li>
              </ul>
            </li>
          ) : (
            ""
          )}
        </ul>
      </aside>
    </>
  );
};

export default Left_panel;
